<template>
    <div class="loading-mask" @click="goToHome">
        <!-- 背景视频 -->
        <video ref="backgroundVideo" class="background-video" autoplay muted @ended="onVideoEnded">
            <source src="/backgroundmov.mov" type="video/mp4">
            您的浏览器不支持视频播放
        </video>

        <!-- 中间logo图片 -->
        <div class="logo-container">
            <img v-if="appparams.logo" :src="getUrl(appparams.logo)" alt="Logo" class="logo-image" />
        </div>
    </div>
</template>

<script>
import appmanagerapi from '@/api/AppManager'
import commonapi from '@/api/common'

export default {
    name: "AppLoading",
    data() {
        return {
            imageUrlCache: {}, // 图片URL缓存
            appparams: {}
        }
    },
    methods: {
        goToHome() {
            // 触发事件通知父组件关闭loading并进入应用
            this.$emit('loading-complete');
        },
        onVideoEnded() {
            // 视频播放完成后自动关闭loading
            this.goToHome();
        },
        // 解析从后端收到的非标准JSON字符串
        parseNonStandardJsonString(jsonString) {
            if (typeof jsonString !== 'string') {
                return jsonString;
            }
            try {
                // 将JS对象写法的字符串修正为标准JSON格式
                // 1. 将键名用双引号包裹： e.g. {key: -> {"key":
                let correctedString = jsonString.replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":');
                // 2. 将值中的单引号替换为双引号： e.g. '/path' -> "/path"
                correctedString = correctedString.replace(/'/g, '"');
                return JSON.parse(correctedString);
            } catch (e) {
                console.error('无法解析后端返回的字符串:', jsonString, e);
                return []; // 返回空数组以防页面崩溃
            }
        },
        getAppData() {
            appmanagerapi.getAppData().then(res => {
                let params = res.data.params;
                if (params.menuList) {
                    params.menuList = this.parseNonStandardJsonString(params.menuList);
                }
                // 将处理后的数据赋值给appparams
                this.appparams = { ...this.appparams, ...params };
            }).catch(error => {
                console.error('获取App数据失败:', error);
            });
        },
        getUrl(imagePath) {
            if (!imagePath) return '';

            // 如果已经有缓存的URL，直接返回
            if (this.imageUrlCache && this.imageUrlCache[imagePath]) {
                return this.imageUrlCache[imagePath];
            }

            // 初始化缓存对象
            if (!this.imageUrlCache) {
                this.imageUrlCache = {};
            }

            // 发起请求获取URL
            commonapi.getImageUrl(imagePath).then(res => {
                const url = res.data.url;
                // 使用Vue.set确保响应式更新
                this.$set(this.imageUrlCache, imagePath, url);
            }).catch(error => {
                console.error('获取图片URL失败:', error);
                // 缓存空字符串，避免重复请求
                this.$set(this.imageUrlCache, imagePath, '');
            });

            // 返回空字符串，等待异步请求完成后通过响应式更新
            return '';
        }
    },
    created() {
        this.getAppData();
    }
};
</script>

<style scoped>
.loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    overflow: hidden;
    cursor: pointer;
}

/* 背景视频样式 */
.background-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
}

/* Logo容器样式 */
.logo-container {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Logo图片样式 */
.logo-image {
    max-width: 200px;
    max-height: 200px;
    width: auto;
    height: auto;
    cursor: pointer;
    transition: all 0.3s ease;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.3));
    animation: logoGlow 2s ease-in-out infinite alternate;
}

.logo-image:hover {
    transform: scale(1.1);
    filter: drop-shadow(0 0 30px rgba(255, 255, 255, 0.6));
}

/* Logo发光动画 */
@keyframes logoGlow {
    0% {
        filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.3));
    }

    100% {
        filter: drop-shadow(0 0 30px rgba(255, 255, 255, 0.6));
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .logo-image {
        max-width: 160px;
        max-height: 160px;
    }
}
</style>